import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#D81846" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center black bold>
            {/* <CFLink
              target="_blank"
              href="https://www.facebook.com/Midam-Broadway-352413878781598/"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Koreana Facebook"
              />
            </CFLink> */}
            <CFLink href="https://www.instagram.com/koreanaeats/">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Koreana Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#D81846" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            {/* <CFLink
              target="_blank"
              href="https://www.facebook.com/Midam-Broadway-352413878781598/"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Koreana Facebook"
                hover
              />
            </CFLink> */}
            <CFLink href="https://www.instagram.com/koreanaeats/">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Koreana Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
